import { mapGetters } from "vuex";
import { can } from "@/utils/clientPermissions";

// usage: v-if="can('balances')"
export default {
  computed: {
    ...mapGetters("userData", ["permissions"]),
  },
  methods: {
    can(permission) {
      // the store is filled after `web/profile`, until then the ones saved in localStorage are used
      const permissions = this.permissions || {};
      return Object.keys(permissions).length
        ? permissions[permission] === true
        : can(permission);
    },
  },
};
